import React, { Component } from "react";

import { StyledButton, Loadable, If } from "components/support";
import { colors } from "assets";

import DownloadStep from "./download-step";
import EditStep from "./edit-step";
import StockCountDropzone from "./dropzone";

import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui-next/Dialog";
import Stepper, { Step, StepLabel } from "material-ui-next/Stepper";

import style from "./style";

class ImportStockCountView extends Component {
  getStepContent = () => {
    switch (this.props.viewModel.activeStep) {
      case 0:
        return (
          <DownloadStep
            downloadCsv={() => this.props.presenter.downloadCsv()}
          />
        );
      case 1:
        return <EditStep />;
      case 2:
        return (
          <StockCountDropzone
            onFileSelect={this.props.onFileSelect}
            status={this.props.status}
          />
        );
      default:
        return "Ooooops...";
    }
  };

  render() {
    const {
      stockCountOpen,
      loading,
      presenter,
      viewModel,
      className
    } = this.props;

    const { activeStep } = viewModel;

    const steps = ["Download", "Edição", "Importação"];

    return (
      <Dialog
        open={stockCountOpen}
        onClose={() => presenter.handleModal()}
        style={{ textAlign: "center" }}
        className={className}
      >
        <Loadable loading={loading}>
          <DialogTitle id="form-dialog-title">Importar Contagem</DialogTitle>

          <DialogContent style={{ width: "500px" }}>
            <div>
              <Stepper
                className="icon-color"
                activeStep={activeStep}
                style={{ padding: "0px 0px 12px 0px" }}
              >
                {steps.map(label => {
                  return (
                    <Step key={label}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
              <div>{this.getStepContent(activeStep)}</div>
            </div>
          </DialogContent>

          <DialogActions>
            <StyledButton
              flat
              accent
              label="Cancelar"
              onTouchTap={() => presenter.handleModal()}
              style={{ margin: "4px 0px 0px 0px", color: colors.accent.normal }}
            />
            <If test={!(activeStep === steps.length)}>
              <If test={activeStep > 0}>
                <StyledButton
                  flat
                  label="Voltar"
                  onTouchTap={() => presenter.handleBack()}
                />
              </If>
              <If test={activeStep === steps.length - 1}>
                <If test={!(this.props.status === "valid")}>
                  <StyledButton
                    style={{ cursor: "not-allowed" }}
                    disabled
                    primary
                    label="Importar"
                  />
                </If>
                <If test={this.props.status === "valid"}>
                  <StyledButton
                    primary
                    label="Importar"
                    onTouchTap={() => presenter.handleImport()}
                  />
                </If>
              </If>
              <If test={!(activeStep === steps.length - 1)}>
                <StyledButton
                  primary
                  label="Próximo"
                  onTouchTap={() => presenter.handleNext()}
                />
              </If>
            </If>
          </DialogActions>
        </Loadable>
      </Dialog>
    );
  }
}
export default style(ImportStockCountView);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/inventory/adjust/import-stock-count/view.jsx